
export const GETMENDATALOADING ="GETMENDATALOADING";
export const GETMENDATASUCCESS = "GETMENDATASUCCESS";
export const GETMENDATAERROR = "GETMENDATAERROR" 
